import getRuleSetByContextId from 'services/api/personalizedPreviewPlacements/getRuleSetByContextId';
import getVariations from 'services/api/personalizedPreviewPlacements/getVariations';
import getRuleDetails from 'services/api/personalizedPreviewPlacements/getRuleDetails';

export default { getRuleSetByContextId, getVariations, getRuleDetails };
